<div class="flex items-center justify-center p-4 pb-8">
  {{ 'shared.noDataPlaceholder' | scTranslate | async }}
</div>
